import whenDomReady from 'when-dom-ready';
import { tns } from 'tiny-slider/src/tiny-slider';
const ACTIVE = 'is-active';
const SINGLE = 'single-btn';
const instances = [];
function initialise() {
    const sections = document.querySelectorAll('.js-tabbed-section-connected');
    sections.forEach(initialiseSection);
    instances.forEach(handleBehavior);
}
export function initialiseSection(section) {
    const track = section.querySelector('.js-tabbed-track');
    if (!track) {
        return;
    }
    // Setup slider instance.
    const instance = tns({
        arrowKeys: false,
        autoplay: false,
        center: true,
        items: 1,
        container: track,
        controls: false,
        gutter: 160,
        loop: false,
        mouseDrag: false,
        nav: false,
        touch: false,
    });
    instances.push(instance);
}
export function handleBehavior(instance) {
    const nav = document.querySelector('.js-tabbed-nav');
    const accordionItems = document.querySelectorAll('.js-accordion-item');
    if (!nav) {
        return;
    }
    instance.events.on('indexChanged', onIndexChanged);
    // Setup navigation buttons.
    const buttons = document.querySelectorAll('.js-tabbed-nav button');
    if (buttons && buttons.length) {
        buttons.forEach((button) => {
            button.addEventListener('click', onButtonClick);
        });
        if (buttons.length === 1) {
            buttons.forEach((button) => {
                button.classList.add(SINGLE);
            });
        }
    }
    // Setup navigation select.
    const selects = document.querySelectorAll('.js-tabbed-nav select');
    if (selects && selects.length) {
        selects.forEach((select) => {
            select.addEventListener('change', onSelectChange);
        });
    }
    /**
     * Handle navigation button click.
     * @param event
     */
    function onButtonClick(event) {
        event.preventDefault();
        if (event.target instanceof HTMLElement) {
            const target = parseInt(event.target.dataset.target || '0', 10);
            instance.goTo(target);
        }
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                accordionItem.classList.remove(ACTIVE);
            });
        }
    }
    /**
     * Handle slider index change.
     * @param event
     */
    function onIndexChanged(info) {
        const nav = document.querySelectorAll('.js-tabbed-nav');
        if (!nav) {
            return;
        }
        nav.forEach((nav) => {
            const navButtons = nav.querySelectorAll('button');
            const navSelects = nav.querySelectorAll('select');
            navButtons.forEach((button) => {
                button.classList.remove(ACTIVE);
                const activeButton = navButtons[info.index];
                if (activeButton) {
                    activeButton.classList.add(ACTIVE);
                }
            });
            navSelects.forEach((select) => {
                select.value = info.index.toString(10);
            });
        });
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                accordionItem.classList.remove(ACTIVE);
            });
        }
        if (accordionItems) {
            accordionItems.forEach((accordionItem) => {
                const content = accordionItem.querySelector('.js-accordion-content');
                if (!content) {
                    return;
                }
                calculateHeight(content);
            });
        }
    }
    /**
     * Handle navigation select change.
     * @param event
     */
    function onSelectChange(event) {
        if (event.target instanceof HTMLSelectElement) {
            const target = parseInt(event.target.value, 10);
            instance.goTo(target);
        }
    }
    if (accordionItems) {
        accordionItems.forEach((accordionItem) => {
            const content = accordionItem.querySelector('.js-accordion-content');
            if (!content) {
                return;
            }
            calculateHeight(content);
        });
    }
    /**
     * Calculate the max height of the specified element.
     * @param element
     */
    function calculateHeight(element) {
        // Cache current value.
        const currentMaxHeight = element.style.maxHeight;
        // Remove max height.
        element.style.maxHeight = 'none';
        // Get current height value.
        const { height } = element.getBoundingClientRect();
        element.style.setProperty('--height', `${height}px`);
        // Reset style back to cached value.
        element.style.maxHeight = currentMaxHeight;
        return height;
    }
}
whenDomReady().then(initialise);
